export const FETCH_PEOPLE_ASSOCIATED_WITH_PROJECT_ID_REQUEST = 'FETCH_PEOPLE_ASSOCIATED_WITH_PROJECT_ID_REQUEST'
export const FETCH_PEOPLE_ASSOCIATED_WITH_PROJECT_ID_SUCCESS = 'FETCH_PEOPLE_ASSOCIATED_WITH_PROJECT_ID_SUCCESS'
export const FETCH_PEOPLE_ASSOCIATED_WITH_PROJECT_ID_FALUIRE = 'FETCH_PEOPLE_ASSOCIATED_WITH_PROJECT_ID_FALUIRE'
